import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ShortTermMemoryTraining.css";

const ShortTermMemoryTraining = () => {
  const navigate = useNavigate();

  // =========================
  // TRAINING SETTINGS
  // =========================

  const [cardCount, setCardCount] = useState(3);
  const [displayTime, setDisplayTime] = useState(5);

  // Card count options
  const cardOptions = [3, 4, 5, 6, 7, 8, 9, 10];

  // Display time options
  const timeOptions = [7, 6, 5, 4, 3, 2];

  // =========================
  // START TRAINING
  // =========================

  const handleStartTraining = () => {
    console.log("Training Started");
    console.log("Number of Cards:", cardCount);
    console.log("Display Time:", displayTime);

    // Send selected settings to training game
    navigate("/short-term-memory-training/play", {
      state: {
        cardCount: cardCount,
        displayTime: displayTime,
      },
    });
  };

  return (
    <div className="training-page">

      {/* =====================================================
          SIDE ORIGINAL PLAYING CARDS
          ===================================================== */}

      {/* LEFT TOP - 3 SPADES */}
      <div className="floating-playing-card side-card-1">

        <div className="side-card-top">
          3♠
        </div>

        <div className="side-card-center">
          ♠
        </div>

        <div className="side-card-bottom">
          3♠
        </div>

      </div>


      {/* RIGHT TOP - 7 HEART */}
      <div className="floating-playing-card side-card-2 red-card">

        <div className="side-card-top">
          7♥
        </div>

        <div className="side-card-center">
          ♥
        </div>

        <div className="side-card-bottom">
          7♥
        </div>

      </div>


      {/* LEFT BOTTOM - 5 CLUB */}
      <div className="floating-playing-card side-card-3">

        <div className="side-card-top">
          5♣
        </div>

        <div className="side-card-center">
          ♣
        </div>

        <div className="side-card-bottom">
          5♣
        </div>

      </div>


      {/* RIGHT BOTTOM - 9 DIAMOND */}
      <div className="floating-playing-card side-card-4 red-card">

        <div className="side-card-top">
          9♦
        </div>

        <div className="side-card-center">
          ♦
        </div>

        <div className="side-card-bottom">
          9♦
        </div>

      </div>


      {/* =====================================================
          MAIN TRAINING CONTAINER
          ===================================================== */}

      <div className="training-container">


        {/* =================================================
            HEADER
            ================================================= */}

        <div className="training-header">

          {/* TOP MINI CARDS */}

          <div className="mini-cards">

            <div className="mini-card mini-card-one">
              3
            </div>

            <div className="mini-card mini-card-two">
              7
            </div>

            <div className="mini-card mini-card-three">
              5
            </div>

          </div>


          {/* TITLE */}

          <h1>
            Short Term Memory

            <span>
              Training
            </span>
          </h1>


          {/* DESCRIPTION */}

          <p>
            Train your memory before taking the actual test.
          </p>

        </div>


        {/* =================================================
            CHOOSE NUMBER OF CARDS
            ================================================= */}

        <div className="selection-box cards-box">

          <div className="selection-title">

            <div className="selection-icon">
              🃏
            </div>

            <h2>
              Choose Number of Cards
            </h2>

          </div>


          <div className="options-grid">

            {cardOptions.map((count) => (

              <button
                key={count}
                type="button"
                className={`option-btn ${
                  cardCount === count
                    ? "active"
                    : ""
                }`}
                onClick={() => setCardCount(count)}
              >
                {count}
              </button>

            ))}

          </div>

        </div>


        {/* =================================================
            CHOOSE DISPLAY TIME
            ================================================= */}

        <div className="selection-box time-box">

          <div className="selection-title">

            <div className="selection-icon clock-icon">
              ◷
            </div>

            <h2>
              Choose Display Time
            </h2>

          </div>


          <div className="time-options">

            {timeOptions.map((time) => (

              <button
                key={time}
                type="button"
                className={`option-btn time-btn ${
                  displayTime === time
                    ? "active"
                    : ""
                }`}
                onClick={() => setDisplayTime(time)}
              >
                {time} sec
              </button>

            ))}

          </div>

        </div>


        {/* =================================================
            SELECTED SETTINGS PREVIEW
            ================================================= */}

        <div className="training-selection-info">

          <span>
            Cards:{" "}
            <strong>
              {cardCount}
            </strong>
          </span>

          <span>
            Display:{" "}
            <strong>
              {displayTime} sec
            </strong>
          </span>

        </div>


        {/* =================================================
            START TRAINING BUTTON
            ================================================= */}

        <button
          type="button"
          className="start-training-btn"
          onClick={handleStartTraining}
        >

          <span className="play-icon">
            ▶
          </span>

          Start Training

        </button>


        {/* =================================================
            TRAINING TIP
            ================================================= */}

        <div className="training-tip">

          <div className="tip-icon">
            💡
          </div>

          <p>
            Start with fewer cards and gradually increase
            the difficulty as you improve.
          </p>

        </div>


      </div>

    </div>
  );
};

export default ShortTermMemoryTraining;